import appConstants from '../../../../../../../appConstants';
import { MultiSelectFilter } from '@dataGrid/components/columnFilters';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = 'GridConfiguration';
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration() {
    return GridConfig.getDefaultConfiguration();
  }

  static getDefaultConfiguration() {
    const defaultConfig = {
      title: `printManifestGrid`,
      keyColumn: 'routeId',
      rowSelection: 'multiple',
      rowDeselection: true,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      columns: [
        {
          headerName: '',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerClass: 'checkBoxHeader',
          cellClassRules: {
            'gridCell-centerAlign': true
          },
          minWidth: appConstants.columnWidth.W_62,
          maxWidth: appConstants.columnWidth.W_62
        },
        {
          headerName: 'Manifest#',
          field: 'manifestNumber',
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_110
        },
        {
          headerName: 'Trailer',
          field: 'trailerNumber',
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120
        }
      ]
    };
    return defaultConfig;
  }
}
